import { API_BASE_URL } from './api';

export type RenderAccessSettings = {
  requireAuthForImageRender: boolean;
  requireAuthForVideoRender: boolean;
};

export const DEFAULT_RENDER_ACCESS_SETTINGS: RenderAccessSettings = {
  requireAuthForImageRender: true,
  requireAuthForVideoRender: true
};

export async function loadRenderAccessSettings(): Promise<RenderAccessSettings> {
  const endpoint = `${API_BASE_URL}/mockups/render-access-settings.json`;
  const response = await fetch(endpoint, { cache: 'no-store' });
  if (!response.ok) {
    throw new Error('Failed to load render access settings');
  }

  const payload = (await response.json()) as Partial<RenderAccessSettings>;
  return {
    requireAuthForImageRender:
      typeof payload.requireAuthForImageRender === 'boolean'
        ? payload.requireAuthForImageRender
        : DEFAULT_RENDER_ACCESS_SETTINGS.requireAuthForImageRender,
    requireAuthForVideoRender:
      typeof payload.requireAuthForVideoRender === 'boolean'
        ? payload.requireAuthForVideoRender
        : DEFAULT_RENDER_ACCESS_SETTINGS.requireAuthForVideoRender
  };
}
